module.exports = __webpack_public_path__ + "img/anewitem-hair-brush.23cf0b50.svg";